import React, { useEffect, useState } from 'react';

import ComboBox from '../../../../components/ComboBox';
import CollapsableSection from '../../../../components/CollapsibleSection';
import ButtonForm from '../../../../components/ButtonForm';
import InputForm from '../../../../components/InputForm';
import SelectableList from '../../../../components/SelectableList';
import SelectionForm from '../../../../components/SelectionForm';

import CheckIco from '../../../../components/icons/CheckIco';
import TrashIco from '../../../../components/icons/TrashIco';
import AddIco from '../../../../components/icons/AddIco';

import Spinner from '../../../../components/Spinner';
import { useAuth } from '../../../../providers/AuthContext';
import { useNavigate } from 'react-router-dom';
import { getAllParameters } from '../../../../services/apiProcessParameteres';
import { useAppContext } from '../../../../providers/AppContext';
import { useProcesses } from '../../../../providers/ProcessesContext';
import { translateDatePicker } from '../../../utils';
import { useDashboards } from '../../../../providers/DashboardContext';
import { useWidgets } from '../../../../providers/WidgetContext';
import { createWidget } from '../../../../services/apiWidgests';


const ColumnField = ({ header , onDelete=() =>{}}) => {
  return (
    <div className='flex justify-between items-center w-full mr-3'>
      <div className='flex basis-1/3 items-center gap-1'>
        <span>{header.alias}</span>
      </div>
      <span className='basis-1/3 text-gray-400'>{header.key}</span>
      <button className="" onClick={() => onDelete(header)}>
        <TrashIco fill='red' />
      </button>
    </div>
  );
};

function TelemetryHorizontalBarChartForm({onSubmit = () => {}}) {
  const {auth} = useAuth();
  const {addToast} = useAppContext();
  const navigate = useNavigate();

  const { addCard, assignSpace } = useWidgets();
  const { dashboard } = useDashboards();

  const [processList, setProcessList] = useState([]);
  const [selectedProcess, setSelectedProcess] = useState();
  const [parameters, setParameters] = useState();
  const [conf, setConf] = useState();
  const {menuItems} = useProcesses();
  const [verticalAxis, setVerticalAxis] = useState();
  const [horizontalAxis, setHorizontalAxis] = useState();
  const [dataRange, setDataRange] = useState('Asignar por dashboard');
  const [title, setTitle] = useState('');
  const [validate, setValidate] = useState(false);
  const [stage,setStage] = useState("form");

  //backend flags
  const [loading, setLoading] = useState(true);
  const [fetchingParameters, setFetchingParameters] = useState(true);
  const [creatingWidget, setCreatingWidget] = useState(false);

  const refreshParameters = () => {
    async function fetchParameters(){
      const parameters = await getAllParameters(selectedProcess, auth?.token);
      return parameters;
    }
    try {
      setFetchingParameters(true);
      fetchParameters().then(response => {
        console.log(console.log(response))
        setParameters(response.map(parameter => {
          return {
            key: parameter.key,
            alias: parameter.alias,
            type: parameter.datatype
          }
        }));
        setFetchingParameters(false);
      }).catch(error => {
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setFetchingParameters(false);
    }
  }

  const createWidgetDB = () => {
    async function fetchWidget(){
      const position= assignSpace();
      const widget = await createWidget({
        type: "processHorizontalBarChart",
        title: title,
        description: "",
        configuration: conf,
        dashboardId: dashboard._id,
        x: position.x,
        y: position.y,
        width: 200,
        height: 200,
      }, auth?.token);
      
      return widget;
    }
    try {
      setCreatingWidget(true);
      fetchWidget().then(response => {
        console.log(console.log(response));
        addCard (
          response._id,
          response.title,
          response.type,
          response.dashboardId,
          
        )
        onSubmit();
        setCreatingWidget(false);
        addToast("Widget "+ title + " creado exitosamente.",1)
      }).catch(error => {
        console.log(error)
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setCreatingWidget(false);
    }
  }

  const selectAxisV = (selectedItems) => {
    if (parameters && selectedItems){
      const axisV = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
      let tempConf = {...conf}
      tempConf.verticalAxis = axisV
      setConf({...tempConf})
    }
    
  }
  const deleteAxisV = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.verticalAxis = undefined
      setConf({...tempConf})
    } 
  }
  const selectAxisH = (selectedItems) => {
    if (parameters && selectedItems){
      const axisH = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
      let tempConf = {...conf}
      tempConf.horizontalAxis = axisH
      setConf({...tempConf})
    }
  }
  const deleteAxisH = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.horizontalAxis = undefined
      setConf({...tempConf})
    } 
  }
 
  const handleProcessChange = (selectedProcess) => {
    let tempConf = {...conf}
    tempConf.verticalAxis = undefined;
    tempConf.horizontalAxis = undefined;
    tempConf.process = {
      id: selectedProcess,
      name: processList[selectedProcess]
    }
    setConf({...tempConf})
  }

  const handleDataRangeChange = (selectedRange) => {
    setDataRange(translateDatePicker(selectedRange));
    let tempConf = {...conf}
    tempConf.dateRange = selectedRange
    setConf({...tempConf})
  }
  const handleDecimalsChange = (decimals) => {
    let tempConf = {...conf}
    tempConf.nDecimals = decimals
    setConf({...tempConf})
  }
  const handleChangeWidgetName = (name) => {
    setTitle(name)
  }
  const handleCreateWidget = () =>{
    
    //createCard("processTable",title, conf, dashboard._id);
    createWidgetDB();
    
  }

  useEffect( () => {
    if (selectedProcess){
      //limpiar headers actuales
        
      //cargar los parametros
      refreshParameters();
      //actualizar la configuracion
      handleProcessChange(selectedProcess);

    }
  }, [selectedProcess]);
  useEffect( () => {

      const bdConf = {
        process: undefined,
        verticalAxis: undefined,
        horizontalAxis: undefined, 
        dateRange: {},
        nDecimals: 2,
        dateFormat: "mm/dd/yy - hh:mm"
      }
  
      setLoading(true);
      //cargar campos
      //cargar conf
      let processOptions = {}
      menuItems.slice(1).map(element => 
        processOptions[element.id] = element.label
      )
      console.log(processOptions);
      setConf(bdConf);
      setProcessList(processOptions);
      setLoading(false);
    }, []);


  useEffect( () => {
    if (stage === "form"){
      
    }
    if (stage === "columnSection"){

    }
  }, []);

  useEffect( () => {
    if (
      title === "" ||
      !conf?.process ||
      !conf.horizontalAxis ||
      !conf.verticalAxis ||
      !conf?.dateRange ||
      !conf?.nDecimals
    ){
      setValidate(false);
    }
    else {
      setValidate(true);
    }
  }, [conf, title])

  return (
    <>
     {stage === "form" && (
      <>
        {conf && (
            <div className='flex flex-col gap-2 h-[35rem] relative overflow-auto'>
            <div className=' flex flex-col flex-grow gap-2'>
              <CollapsableSection title={"Datos"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' open={true} border={false}>
                <div className='flex flex-col gap-2'>
                  <div className='flex justify-between items-center w-[50%] mb-1.5'>
                    <SelectionForm
                      text="Proceso" 
                      options={Object.keys(processList)} 
                      mask={processList} 
                      value={selectedProcess}
                      onChange={event => setSelectedProcess(event)}
                      AppendClassName=' -mb-4'
                      error={!!selectedProcess && !fetchingParameters && parameters.length === 0 ? 'El proceso no tiene parametros creados' : ""}
                    /> 
                  
                  </div>
                 
                    <CollapsableSection 
                      title={"Eje vertical"}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='w-full flex flex-col px-4'>
                        { conf.verticalAxis && (
                          <ColumnField header={conf.verticalAxis} onDelete={deleteAxisV}/>
                        )}
                        { !conf.verticalAxis && (
                          <div className=' mx-auto'>
                            <ButtonForm 
                              text={"Agregar campo"} 
                              Icon={() => {return (<AddIco fill='white'/>)}} 
                              enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                              action={ () => setStage("setVerticalAxis")}
                            />
                          </div>
                        )}
                      </div>
                    </CollapsableSection>

                    <CollapsableSection
                      title={"Eje horizontal (datos numéricos)"}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='w-full flex flex-col px-4'>
                        { conf.horizontalAxis && (
                          <ColumnField header={conf.horizontalAxis} onDelete={deleteAxisH}/>
                        )}
                        { !conf.horizontalAxis && (
                          <div className=' mx-auto'>
                            <ButtonForm 
                              text={"Agregar campo"} 
                              Icon={() => {return (<AddIco fill='white'/>)}} 
                              enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                              action={ () => setStage("setHorizontalAxis")}
                            />
                          </div>
                        )}
                      </div>
                    </CollapsableSection>
                  
                  <div className='-mb-5 pt-4'>
                    <InputForm 
                      type={"datarange"} 
                      text={"Rango de tiempo"} 
                      value={dataRange} 
                      AppendClassName='text-left' 
                      onChange={(event) => handleDataRangeChange(event)}
                      dateRangeOptions={conf.dateRange}
                      addedRanges={ {"byDashboard": () => {}}} 
                    />
                  </div>
                  
                </div>
              </CollapsableSection>
              <CollapsableSection title={"Apariencia"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' border={false} open={true}>
                <InputForm text={"Nombre"} value={title} onChange={(event) => setTitle(event.target.value)}/>
                <InputForm type={"number"} text={"Decimales"} value={conf.nDecimals} onChange={(event) => handleDecimalsChange(event.target.value)}/>
                <InputForm type={"button"} text={"Estilo"} value={"Modificar estilo"} AppendClassName='text-left' />
              </CollapsableSection>
            </div>

            {/* Span fijo al final del contenedor */}
            <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
              <div className='flex w-full justify-end'>
                  <button className='' onClick={() => handleCreateWidget()}  disabled={!validate}>
                    <CheckIco width='50px' height='50px' fill={validate ? 'bluesens': 'gray'}/>
                  </button>
              </div>
            </div>
          </div>
        )}
        {!conf && (
          <Spinner />
        )}
      </>
      
      
     )}
     {stage === "setVerticalAxis" && (
      <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
        <div className=' flex flex-col flex-grow gap-2'>
          <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
            <SelectableList 
              items={parameters.filter(element => !element.type ).map(element => element.alias ? element.alias : element.key)} 
              multiSelect={false} 
              setItems={selectAxisV}
            />
        </div>
        
        {/* Span fijo al final del contenedor */}
        <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
          <div className='flex w-full justify-end'>
            < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
          </div>
        </div>
      </div>
     )}
     {stage === "setHorizontalAxis" && (
      <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
        <div className=' flex flex-col flex-grow gap-2'>
          <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
          <SelectableList 
            items={parameters.filter(element => element.type === "numeric").map(element => element.alias ? element.alias : element.key)} 
            multiSelect={false} 
            setItems={selectAxisH}
          />
        </div>
        
        {/* Span fijo al final del contenedor */}
        <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
          <div className='flex w-full justify-end'>
            < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
          </div>
        </div>
      </div>
     )}
    </>
   
    
  );
}

export default TelemetryHorizontalBarChartForm;
